import { AboutAppState } from 'mk2/apps/about/reducers';
import { AdminclubAppState, adminclubReducer } from 'mk2/apps/adminclub/reducers';
import { BazaarAppState } from 'mk2/apps/bazaar/reducers';
import { BlogsAppState, blogsReducer } from 'mk2/apps/blogs/reducers';
import { BoAppState } from 'mk2/apps/bo/reducers';
import { State as CounsellingsState } from 'mk2/apps/counsellings/reducers';
import { DashAppState } from 'mk2/apps/dash/reducers';
import { ForumAppState, forumReducer } from 'mk2/apps/forum/reducers';
import { GroupsAppState } from 'mk2/apps/groups/reducers';
import { HeartsAppState } from 'mk2/apps/hearts/reducers';
import { HomeAppState } from 'mk2/apps/home/reducers';
import { MailAppState } from 'mk2/apps/mail/reducers';
import { SettingsAppState } from 'mk2/apps/settings/reducers';
import { StrollersAppState } from 'mk2/apps/strollers/reducers';
import { UsersAppState } from 'mk2/apps/users/reducers';
import { WallAppState } from 'mk2/apps/wall/reducers';
import { WikiAppState } from 'mk2/apps/wiki/reducers';
import ab, * as fromAB from 'mk2/containers/AB/AB.reducers';
import * as fromActionButton from 'mk2/containers/ActionButton/ActionButton.reducers';
import adSlot, * as fromAdSlot from 'mk2/containers/AdSlot/AdSlot.reducers';
import {
    AdSlotInterstialState,
    adSlotInterstitialReducer,
} from 'mk2/containers/AdSlotInterstitial/AdSlotInterstitial.reducers';
import complaint, * as fromComplaint from 'mk2/containers/Complaint/Complaint.reducers';
import deletion, * as fromDeletion from 'mk2/containers/Deletion/Deletion.reducers';
import installPrompt, { State as InstallPromptState } from 'mk2/containers/InstallPrompt/InstallPrompt.reducers';
import * as fromLike from 'mk2/containers/Like/Like.reducers';
import menu, * as fromMenu from 'mk2/containers/Menu/Menu.reducers';
import * as fromPageHeader from 'mk2/containers/PageHeader/PageHeader.reducers';
import phoneVerification, * as fromPhoneVerification from 'mk2/containers/PhoneVerification/PhoneVerification.reducers';
import phoneVerificationModal, * as fromPhoneVerificationModal from 'mk2/containers/PhoneVerificationModal/PhoneVerificationModal.reducers';
import * as fromStar from 'mk2/containers/Star/Star.reducers';
import * as fromToolbar from 'mk2/containers/Toolbar/Toolbar.reducers';
import { UserAgentParsed } from 'mk2/helpers/detects';
import * as fromMKReduxForms from 'mk2/helpers/form.reducers';
import * as fromEntities from 'mk2/reducers/entities';
import request, * as fromRequest from 'mk2/reducers/request';
import response, * as fromResponse from 'mk2/reducers/response';
import { Entity } from 'mk2/schemas';
import { reducer as toastrReducer } from 'react-redux-toastr';
import { routerReducer, RouterState } from 'react-router-redux';

// pociatocny stav ktory nam poskytne server (node/django)
//
// keep in sync with redux_initial_state() in context.py
export interface AppStateProvidedFromServer {
    request: fromRequest.RequestStateProvidedFromServer;
    containers: {
        global: {
            pageHeader: fromPageHeader.PageHeaderState;
        },
    };
}

export interface AppState extends AppStateProvidedFromServer {
    routing: RouterState;
    form: fromMKReduxForms.MKReduxFormsState;
    toastr: any; // TODO @type: Add react-router-toastr

    request: fromRequest.RequestState;
    response: fromResponse.ResponseState;

    entities: fromEntities.EntitiesState;
    containers: {
        global: {
            ab: fromAB.State;
            adSlot: fromAdSlot.AdSlotState;
            adSlotInterstitial: AdSlotInterstialState;
            complaint: fromComplaint.ComplaintsState;
            deletion: fromDeletion.DeletionsState;
            toolbar: fromToolbar.ToolbarsState;
            menu: fromMenu.MenuState;
            pageHeader: fromPageHeader.PageHeaderState;
            phoneVerification: fromPhoneVerification.PhoneVerificationState;
            phoneVerificationModal: fromPhoneVerificationModal.PhoneVerificationModalState;
            actionButtons: fromActionButton.ActionButtonsState;
            installPrompt: InstallPromptState;
            // newsletterModal: fromNewsletterModal.NewsletterModalState;
        },
        about: AboutAppState;
        adminclub: AdminclubAppState;
        bazaar: BazaarAppState;
        bo: BoAppState;
        dash: DashAppState;
        mail: MailAppState;
        wall: WallAppState;
        home: HomeAppState;
        hearts: HeartsAppState;
        forum: ForumAppState;
        groups: GroupsAppState;
        blogs: BlogsAppState;
        settings: SettingsAppState;
        wiki: WikiAppState;
        strollers: StrollersAppState;
        users: UsersAppState;
        counsellings: CounsellingsState;
    };
}

const reducers = {
    // Libs
    routing: routerReducer,
    form: fromMKReduxForms.mkReduxFormsReducer,
    toastr: toastrReducer,

    // Ours
    request,
    response,

    entities: fromEntities.entitiesReducer,

    containers: {
        global: {
            ab,
            adSlot,
            adSlotInterstitial: adSlotInterstitialReducer,
            complaint,
            deletion,
            toolbar: fromToolbar.toolbarsReducer,
            menu,
            pageHeader: fromPageHeader.pageHeaderReducer,
            phoneVerification,
            phoneVerificationModal,
            actionButtons: fromActionButton.actionButtonsReducer,
            installPrompt,
            // newsletterModal,
        },
        forum: forumReducer,
        blogs: blogsReducer,
        adminclub: adminclubReducer,
    },
};

export default reducers;

// Export selectors from request
export const getRequestBaseUrl = (state: AppState) => fromRequest.getBaseUrl(state.request);
export const getRequestUser = (state: AppState) => fromRequest.getUser(state.request);
export const getRequestPermissions = (state: AppState) => fromRequest.getPermissions(state.request);
export const getRequestSettings = (state: AppState) => fromRequest.getSettings(state.request);
export const getRequestUserAgent = (state: AppState): UserAgentParsed => state.request.userAgent;
export const getRequestDevice = (state: AppState) => fromRequest.getDevice(state.request);
export const getRequestDeviceViewport = (state: AppState) => fromRequest.getDeviceViewport(state.request);
export const getRequestDeviceMobile = (state: AppState) => fromRequest.getDeviceMobile(state.request);
export const getRequestDeviceDesktop = (state: AppState) => fromRequest.getDeviceDesktop(state.request);
export const getRequestDeviceKeyboard = (state: AppState) => fromRequest.getDeviceKeyboard(state.request);
export const getRequestPhoneVerificationMode = (state: AppState) => fromRequest.getPhoneVerificationMode(state.request);
export const getRequestDeviceIsIOS = (state: AppState): boolean =>
    state.request.userAgent && state.request.userAgent.os && state.request.userAgent.os.name === 'iOS';
export const getRequestLastKnownUsername = (state: AppState): string => state.request.lastKnownUsername;
export const getRequestPrivacyLeaflet = (state: AppState) => fromRequest.getPrivacyLeaflet(state.request);
// export const getNewsletterModalSubscribed = (state: AppState) => fromRequest.getPregnancyNewsletterSubscribed(state.request);
// export const getNewsletterModalClosed = (state: AppState) => fromRequest.getPregnancyNewsletterClosed(state.request);
export const getNewGroupsEnabled = (state: AppState) => fromRequest.getNewGroupsEnabled(state.request);
export const getRequestWebpush = (state: AppState) => fromRequest.getWebpush(state.request);

export const getActionButtonState = (state: AppState, buttonId: string): fromActionButton.ActionButtonState =>
    state.containers.global.actionButtons[buttonId] || fromActionButton.initialActionButtonState;

// Export selectors from response
export const getResponseRenderedAt = (state: AppState) => fromResponse.getRenderedAt(state.response);

// Export selectors from entities
export const getEntitiesEntity = (state: AppState, entity: string, id: number | string): Entity => fromEntities.getEntity(state.entities, entity, id);

export const getFormState = (state: AppState, formName: string): fromMKReduxForms.MKReduxFormState =>
    state.form[formName] || fromMKReduxForms.initialMKReduxFormState;

// Export selectors from like
// Note: We are reading state from entities, because that is where the likeable enttiy is storred
export const getLikeIsLiked = (state: AppState, entity: string, id: number) => fromLike.getIsLiked(state.entities.likeable as fromLike.LikeableEntitiesState, entity, id);
export const getLikeLikesCount = (state: AppState, entity: string, id: number) => fromLike.getLikesCount(state.entities.likeable as fromLike.LikeableEntitiesState, entity, id);

// Export selectors from toolbar
export const getToolbarState = (state: AppState, formName: string): fromToolbar.ToolbarState =>
    state.containers.global.toolbar[formName] || fromToolbar.initialToolbarState;

// Export selectors from menu
export const getMenuShow = (state: AppState, menuId: string) => fromMenu.getShow(state.containers.global.menu, menuId);

// Forum
export const getPageHeaderState = (state: AppState): fromPageHeader.PageHeaderState => state.containers.global.pageHeader;

// Export selectors from phoneVerification
export const getPhoneVerificationStep = (state: AppState) => fromPhoneVerification.getStep(state.containers.global.phoneVerification);
export const getPhoneVerificationPrefix = (state: AppState) => fromPhoneVerification.getPrefix(state.containers.global.phoneVerification);
export const getPhoneVerificationPhoneNumber = (state: AppState) => fromPhoneVerification.getPhoneNumber(state.containers.global.phoneVerification);
export const getPhoneVerificationLimitReached = (state: AppState) => fromPhoneVerification.getLimitReached(state.containers.global.phoneVerification);
export const getPhoneVerificationSending = (state: AppState) => fromPhoneVerification.getSending(state.containers.global.phoneVerification);

// Export selectors from phoneVerificationModal
export const getPhoneVerificationModalOpened = (state: AppState) => fromPhoneVerificationModal.getOpened(state.containers.global.phoneVerificationModal);
export const getPhoneVerificationModalMode = (state: AppState) => fromPhoneVerificationModal.getMode(state.containers.global.phoneVerificationModal);

// Export selectors from newsletterModal
// export const getNewsletterModalOpened = (state: AppState) => fromNewsletterModal.getOpened(state.containers.global.newsletterModal);
// export const getNewsletterModalSubmitted = (state: AppState) => fromNewsletterModal.getSubmitted(state.containers.global.newsletterModal);
